export default __webpack_public_path__ + "static/181-b2066a5875b6efd96678148d2f4beb38.jpg";